import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import SelectableChip from 'retired/SelectableChip';
import FormLocationSelector from 'retired/FormLocationSelector';
import FormSelectBoxEntitySelector from 'retired/FormSelectBoxEntitySelector';
import OrganizationApi from 'entities/organization/api';
import { selectOrganization, selectAccessibleUserLocations } from 'entities/user/selectors';

import { selectFetchParams } from './selectors';
import { setFetchParamsAction } from './actions';

const Filters = (): JSX.Element | null => {
  const fetchParams = useSelector(selectFetchParams);
  const locations = useSelector(selectAccessibleUserLocations);
  const dispatch = useDispatch();
  const organization = useSelector(selectOrganization);
  const isCompany = organization?.isCompany();
  const options = [
    {
      status: null,
      label: 'All',
    },
    {
      status: 'pending',
      label: 'Pending',
    },
    {
      status: 'accepted',
      label: 'Approved',
    },
    {
      status: 'rejected',
      label: 'Rejected',
    },
    {
      status: 'inactive',
      label: 'Inactive',
    },
  ];

  if (!isCompany) {
    return null;
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <div style={{ marginBottom: 10 }}>
          {options.map((option) => {
            const selected = fetchParams.get('status') === option.status;
            return (
              <SelectableChip
                key={option.status || 'all'}
                label={option.label}
                onClick={(): void => {
                  if (!selected) {
                    dispatch(setFetchParamsAction({ status: option.status }));
                  }
                }}
                selected={selected}
              />
            );
          })}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            marginBottom: 10,
          }}
        >
          <FormLocationSelector
            input={{
              onChange: (value: string[]): void => {
                dispatch(setFetchParamsAction({ locations: value }));
              },
              value: fetchParams.get('locations'),
            }}
            locations={locations}
            placeholder="Filter by Location"
            style={{ marginRight: 10 }}
          />
          <FormSelectBoxEntitySelector
            multiple
            showSearch
            // eslint-disable-next-line @typescript-eslint/unbound-method
            fetchOptions={OrganizationApi.fetchDepartments}
            placeholder="Filter by Department"
            input={{
              onChange: (value: string[]): void => {
                dispatch(setFetchParamsAction({ departments: value }));
              },
              value: fetchParams.get('departments'),
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Filters;
